import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { publishersInvite } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type InvitePublishersParams = {
  publisherIds: number[];
};

export const useInvitePublishers = (
  options: UseMutationOptions<
    unknown,
    unknown,
    InvitePublishersParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ publisherIds }: InvitePublishersParams) => {
      return extractData(
        publishersInvite({
          body: {
            publishers: publisherIds,
          },
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['publishers'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
